import { HTTP_400_BAD_REQUEST } from '@config/const';
import { configuredFetchBaseQuery } from '@config/rtkQuery';
import {
  defaultRejectOptions,
  toastFulfilledPromise,
  toastPendingPromise,
  toastRejectedPromise,
} from '@features/promiseHandlers';
import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/dist/query/react';

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: configuredFetchBaseQuery(),
  endpoints: (builder) => ({
    getDetails: builder.query({
      query: () => ({ url: 'customer/details' }),
      providesTags: ['CustomerDetails'],
    }),
    changePassword: builder.mutation({
      query: ({ oldPassword, newPassword, newPasswordConfirm }) => ({
        url: `customer/password/change`,
        method: 'POST',
        body: {
          old_password: oldPassword,
          new_password1: newPassword,
          new_password2: newPasswordConfirm,
        },
      }),
      invalidatesTags: ['CustomerDetails'],
    }),
  }),
});

const initialState = {
  details: { isLoading: false, data: {} },
  contacts: { isLoading: false, data: [] },
  mailSubscription: { isLoading: false, data: [] },
  contactLevels: { isLoading: false, data: [] },
  contactTypes: { isLoading: false, data: [] },
  toast: {},
};

const userSettingsSlice = createSlice({
  name: 'userSettings',
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addMatcher(
        userApi.endpoints.changePassword.matchPending,
        (state, action) =>
          toastPendingPromise(state, action, 'Requesting change password...')
      )
      .addMatcher(
        userApi.endpoints.changePassword.matchFulfilled,
        (state, action) =>
          toastFulfilledPromise(state, action, {
            render: action.payload?.detail || 'Password changed.',
          })
      )
      .addMatcher(
        userApi.endpoints.changePassword.matchRejected,
        (state, action) =>
          toastRejectedPromise(state, action, {
            ...defaultRejectOptions,
            render:
              action.payload.status === HTTP_400_BAD_REQUEST
                ? 'Check form errors.'
                : 'Error occurred.',
          })
      ),
});

export default userSettingsSlice.reducer;
